import { Component, OnInit } from '@angular/core';
import { FuseConfigService } from '@fuse/services/config.service';
///IDIOMAS
import { lang_login } from 'app/idiomas/i18n/login/login.lang';
import { lang_idiomas } from 'app/idiomas/i18n/idiomas/idiomas.lang';
import { FuseTranslationLoaderService } from '@fuse/services/translation-loader.service';

import { TranslateService } from '@ngx-translate/core';
import { Router } from '@angular/router';

@Component({
  selector: 'login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit {
  languages: any;
  selectedLanguage: any;

  constructor(
    private _fuseConfigService: FuseConfigService,
    private _fuseTranslationLoaderService: FuseTranslationLoaderService,
    private _translateService: TranslateService,
    private router: Router,
  ) {
    lang_login.forEach((locale) => {
        this._fuseTranslationLoaderService.loadTranslations(locale);
    });
    lang_idiomas.forEach((locale) => {
      this._fuseTranslationLoaderService.loadTranslations(locale);
    });
    this._fuseConfigService.config = {
        layout: {
            navbar   : {hidden: true},
            toolbar  : {hidden: true},
            footer   : {hidden: true},
            sidepanel: {hidden: true}
        }
    };
    this.languages = [
        {
            id   : 'en',
            title: 'English',
            flag : 'us',
            short: 'en'
        },
        {
            id   : 'es',
            title: 'Español',
            flag : 'es',
            short: 'es'
        },
        {
            id   : 'tr',
            title: 'Turkish',
            flag : 'tr',
            short: 'tr'
        },
        {
          id   : 'zh1',
          title: 'Traditional Chinese',
          flag : 'zh',
          short: 'zh'
        },
        {
          id   : 'zh2',
          title: 'Simplified Chinese',
          flag : 'zh',
          short: 'zh'
        }
    ];
  }
  setLanguage(lang): void
  {
      // console.log(lang);
      // Set the selected language for the toolbar
      this.selectedLanguage = lang;

      // Use the selected language for translations
      this._translateService.use(lang);
      // this._translateService.use(lang.id);
  }
  ngOnInit() {
    let langAct = this._translateService.currentLang;
    this.setLanguage(langAct);
  }
  navigateToEncuesta(ruta){
    this.router.navigate([ruta]);
  }
}
